export default __webpack_public_path__ + "static/media/expand.db4d715f.svg";